import type { DbLibraryBlock } from '@domain/schemas/block.schema';
import type { ResourceBlock } from '@domain/schemas/contract.schema';

/**
 * Library blocks live outside any section, but the SPA previews and edits them through the contract block
 * components, which are typed for blocks inside a section (`section_id`, template flags). This is the one place
 * that bridges the two shapes. The empty `section_id` stays out of library-block requests because the library
 * payload key lists in `block-edit/constants.ts` are checked against the library payload types, which have no
 * `section_id`.
 */
export const asResourceBlock = (block: DbLibraryBlock): ResourceBlock => ({
  ...block,
  section_id: '',
  canDeleteOnTemplate: block.canDeleteOnTemplate ?? true,
});
